import { render } from "./endconfirm_modal.vue?vue&type=template&id=22f4085c"
import script from "./endconfirm_modal.vue?vue&type=script&lang=js"
export * from "./endconfirm_modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260727231353/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__